/* eslint-disable import/prefer-default-export */
// @flow

export const mapBooleanToYesNo = (value: boolean) => {
  if (value === true) {
    return "Ja";
  }

  if (value === false) {
    return "Nein";
  }

  return value;
};
